/**
 * @file     downPayment.ts
 * @purpose  Single source of truth for Canada's minimum residential down
 *           payment and insured-mortgage purchase-price eligibility.
 */

/** Government-backed mortgage insurance requires a purchase price below this amount. */
export const INSURED_MORTGAGE_PRICE_CAP = 1_500_000;

export function isInsuredMortgagePriceEligible(price: number): boolean {
  return Number.isFinite(price) && price > 0 && price < INSURED_MORTGAGE_PRICE_CAP;
}

/**
 * Minimum legal down payment for an owner-occupied residential purchase:
 * 5% through $500,000, 10% on the balance below $1.5M, and 20% at $1.5M+
 * because government-backed mortgage insurance is unavailable there.
 */
export function minimumDownPayment(price: number): number {
  if (!Number.isFinite(price) || price <= 0) return 0;
  if (!isInsuredMortgagePriceEligible(price)) return Math.round(price * 0.2);
  if (price <= 500_000) return Math.round(price * 0.05);
  return Math.round(500_000 * 0.05 + (price - 500_000) * 0.1);
}
